import React from 'react';

import styled from 'styled-components';

import Collage from 'components/ModularBlocks/TwoBlockContent/components/Collage';

import { AssetI } from 'interfaces/content-stack/contentStack.types';

const ImageContainer = styled.div<{ $boxShadow?: boolean }>`
  display: flex;
  height: 100%;
  align-items: center;
  box-shadow: ${(props) =>
    props.$boxShadow ? `0 .5rem 1.25rem 0.375rem ${props.theme.colors.secondaryBoxShadowGray}` : 'none'};

  picture {
    display: flex;
    height: 100%;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
    justify-content: center;
    aspect-ratio: 1.565/1;
    margin: 0 auto;
  }

  img {
    object-fit: ${(props) => (props.$boxShadow ? 'cover' : 'contain')};
    width: 100%;
  }
`;

type Props = {
  altText?: string | undefined;
  images?: AssetI[] | undefined;
  boxShadow?: boolean;
};

const BlockImage: React.FC<Props> = ({ altText = 'uploaded image', images, boxShadow }) => {
  const imageCount = images?.length ?? 0;

  if (imageCount < 1) {
    return null;
  }

  const queryParams = `?format=pjpg&auto=webp&quality=80&width=1000&disable=upscale`;
  const mobileQueryParams = '?format=pjpg&auto=webp&quality=80&width=600&disable=upscale';
  const imgSrc = images && images[0]?.url;
  const optimizedImgSrc = imgSrc + queryParams;
  const optimizedMobileImgSrc = imgSrc + mobileQueryParams;

  return (
    <>
      {imageCount === 1 && (
        <ImageContainer $boxShadow={boxShadow}>
          <picture>
            <source media='(max-width: 480px)' srcSet={optimizedMobileImgSrc} />
            <img alt={altText} src={optimizedImgSrc} loading='lazy' />
          </picture>
        </ImageContainer>
      )}
      {imageCount > 1 && <Collage altText={altText} images={images} />}
    </>
  );
};

export default BlockImage;
